/***********************************************************************************
 * Vuetify plugin
 *
 * @author Zip Co - Plugin Team
 *
 ***********************************************************************************/

import Vue from 'vue';
import Vuetify from 'vuetify';
import ThemeColors from '@/themes/ThemeColors';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'md'
    },
    themes: {
        primary: ThemeColors.PRIMARY,
        secondary: ThemeColors.SECONDARY,
        accent: ThemeColors.ACCENT,
        tertiary: ThemeColors.TERTIARY,
        error: ThemeColors.ERROR,
        warning: ThemeColors.WARNING
    }
});
